export const REPORTING_STOCK_BALANCE = 'REPORTING_STOCK_BALANCE';
export const REPORTING_INVENTORY = 'REPORTING_INVENTORY';
export const REPORTING_INVENTORY_META = 'REPORTING_INVENTORY_META';
export const REPORTING_NETSUITE_REPORT = 'REPORTING_NETSUITE_REPORT';
